module.exports = __webpack_public_path__ + "static/media/Oxygen-Bold.3768d450.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/OxygenBold/Oxygen-Bold.ttf
// module id = 2942
// module chunks = 0